/** Trim + normalize email so paste/autofill quirks do not break login. */
export function normalizeLoginEmail(value) {
  return String(value || "")
    .trim()
    .replace(/\u00a0/g, " ")
    .toLowerCase();
}

/** Prefer API message (e.g. unverified email) over a generic wrong-password string. */
export function messageFromLoginResponse(data) {
  if (!data || typeof data !== "object") return null;
  const d = data.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d) && d.length && typeof d[0] === "string") return d[0];
  if (data.error && typeof data.error === "string") return data.error;
  return null;
}
